import BaseService from 'services/base-service';

export class PoliciesStore extends BaseService {
  async checkLimit(projectId: string) {
    return await this.service.apiClient.environments.checkLimit(projectId);
  }
}
